import { gql } from '@apollo/client';

const DATA_FIX_USER_FRAGMENT = gql`
  fragment DataFixUserFields on DataFixUser {
    id
    firstName
    lastName
  }
`;

export const DATA_FIX_REQUESTS_QUERY = gql`
  query DataFixRequests($input: DataFixRequestsInput!) {
    dataFixRequests(input: $input) {
      rows {
        id
        workflow
        team
        entityType
        scope
        sourceId
        targetId
        matchId
        actionType
        status
        reason
        notes
        requestedBy {
          ...DataFixUserFields
        }
        resolvedBy {
          ...DataFixUserFields
        }
        createdAt
        updatedAt
        resolvedAt
      }
      total
    }
  }
  ${DATA_FIX_USER_FRAGMENT}
`;

export const DATA_FIX_REQUEST_QUERY = gql`
  query DataFixRequest($id: ID!) {
    dataFixRequest(id: $id) {
      id
      workflow
      team
      entityType
      scope
      sourceId
      targetId
      matchId
      actionType
      status
      reason
      payload
      details
      notes
      requestedBy {
        ...DataFixUserFields
      }
      resolvedBy {
        ...DataFixUserFields
      }
      createdAt
      updatedAt
      resolvedAt
    }
  }
  ${DATA_FIX_USER_FRAGMENT}
`;

export const DATA_FIX_REQUEST_PREVIEW_QUERY = gql`
  query DataFixRequestPreview($id: ID!) {
    dataFixRequestPreview(id: $id) {
      sourceId
      targetId
      matches {
        matchId
        matchName
      }
    }
  }
`;

export const DATA_FIX_TEAM_QUERY = gql`
  query DataFixTeam($id: ID!) {
    dataFixTeam(id: $id) {
      id
      name
    }
  }
`;

export const DATA_FIX_MATCH_QUERY = gql`
  query DataFixMatch($id: ID!) {
    dataFixMatch(id: $id) {
      id
      name
    }
  }
`;

export const DATA_FIX_PLAYER_QUERY = gql`
  query DataFixPlayer($id: ID!) {
    dataFixPlayer(id: $id) {
      id
      name
    }
  }
`;
